<template>
  <div>
    <div
      class="c-survey__wrapper"
      :class="[{ 'c-survey__wrapper--transition': isTransitioning }]"
    >
      <AnimationBackground></AnimationBackground>
      <Transition
        :name="transitionName"
        @before-enter="beforeEnter"
        @before-leave="beforeLeave"
        @after-enter="afterEnter"
        @after-leave="afterLeave"
        v-on:enter="enter"
        v-on:leave="leave"
      >
        <component :is="screenList[currentScreenIndex].component" />
      </Transition>
      <!-- <Footer></Footer> -->
    </div>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";

import WelcomeView from "./components/views/WelcomeView.vue";
import IntroView from "./components/views/IntroView.vue";
import PageOneView from "./components/views/PageOneView.vue";
import PageTwoView from "./components/views/PageTwoView.vue";
import PageThreeView from "./components/views/PageThreeView.vue";
import PageFourView from "./components/views/PageFourView.vue";
import SummaryView from "./components/views/SummaryView.vue";
import FeedbackView from "./components/views/FeedbackView.vue";
import ThankyouView from "./components/views/ThankyouView.vue";
import LiveResultsView from "./components/views/LiveResultsView.vue";
import Footer from "./components/Footer.vue";
import AnimationBackground from "./components/AnimationBackground.vue";
import { gsap } from "gsap";

export default {
  data() {
    return {
      isSmallScreen: window.innerWidth < 1200,
      currentLeaveElHeight: "0px",
      currentEnterElHeight: "0px",
    };
  },
  components: {
    WelcomeView,
    IntroView,
    PageOneView,
    PageTwoView,
    PageThreeView,
    PageFourView,
    SummaryView,
    FeedbackView,
    ThankyouView,
    LiveResultsView,
    Footer,
    AnimationBackground,
  },
  computed: {
    ...mapFields([
      "content",
      "currentScreenIndex",
      "screenList",
      "navigationDirection",
      "submissionData",
      "isTransitioning",
    ]),
    transitionName() {
      const screen = this.screenList[this.currentScreenIndex];
      console.log(this.navigationDirection);
      console.log(screen.component);

      return this.navigationDirection === "next"
        ? screen.nextTransition
        : screen.prevTransition;
    },
  },
  methods: {
    checkScreenWidth() {
      const screenWidth = window.innerWidth;
      this.isSmallScreen = screenWidth < 1366;
    },
    beforeLeave(el) {
      this.currentLeaveElHeight = el.clientHeight + "px";
      if ($(".fade-down-enter")[0]) {
        this.currentEnterElHeight =
          $(".fade-down-enter")[0].clientHeight + "px";
      }
    },
    beforeEnter(el) {
      this.isTransitioning = true;
    },
    afterEnter(el) {},
    afterLeave(el) {
      this.isTransitioning = false;
    },
    enter: function (el, done) {
      this.currentEnterElHeight = el.clientHeight + "px";
      var tl = gsap.timeline();

      if (this.transitionName == "fade-up") {
        tl.fromTo(
          el,
          {
            y: this.currentLeaveElHeight,
          },
          {
            y: "0",
            duration: 2.5,
          }
        );
      } else if (this.transitionName == "fade-down") {
        tl.fromTo(
          el,
          {
            y: "-" + this.currentEnterElHeight,
          },
          {
            y: "0",
            duration: 2.5,
          }
        );
      }

      if ($(".timeline-1-animation-3--up-and-out")[0]) {
        tl.to(
          $(".timeline-1-animation-3--up-and-out")[0],
          {
            y: "-" + this.currentLeaveElHeight,
            duration: 2.5,
          },
          0
        );
      } else if ($(".timeline-1-animation-3--up")[0]) {
        tl.to(
          $(".timeline-1-animation-3--up")[0],
          {
            y: "0",
            duration: 2.5,
          },
          0
        );
      } else if ($(".timeline-1-animation-3")[0]) {
        tl.to(
          $(".timeline-1-animation-3")[0],
          {
            y: "100%",
            duration: 2.5,
          },
          0
        );
      }

      //We set a timeout here rather than oncomplete of timeline
      //This is because we are also using css transitions which are 2.5s long
      setTimeout(() => {
        done();
      }, 2500);
    },
    leave: function (el, done) {
      var tl = gsap.timeline();
      if (this.transitionName == "fade-up") {
        tl.fromTo(
          el,
          {
            y: "0",
          },
          {
            y: "-100%",
            duration: 2.5,
          }
        );
      } else if (this.transitionName == "fade-down") {
        tl.fromTo(
          el,
          {
            y: "0",
          },
          {
            y: this.currentEnterElHeight,
            duration: 2.5,
          }
        );
      }

      //We set a timeout here rather than oncomplete of timeline
      //This is because we are also using css transitions which are 2.5s long
      setTimeout(() => {
        done();
      }, 2500);
    },
  },
  mounted() {
    window.addEventListener("resize", this.checkScreenWidth);
    this.checkScreenWidth();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkScreenWidth);
  },
};
</script>
<style lang="scss"></style>
